/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createSlice } from "@reduxjs/toolkit";

import { RequestStatus } from "~/constants";
import { resetPasswordAsync, sendForgotPasswordAsync } from "~/features/forgotPassword/thunks";
import { ForgotPasswordState } from "~/features/forgotPassword/types";

const initialState: ForgotPasswordState = {
  forgotPasswordStatus: RequestStatus.IDLE,
  forgotPasswordEmail: null,
  resetPasswordStatus: RequestStatus.IDLE,
};

const slice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    resetForgotPassword: (state) => {
      state.forgotPasswordStatus = RequestStatus.IDLE;
      state.forgotPasswordEmail = null;
    },
    resetResetPassword: (state) => {
      state.resetPasswordStatus = RequestStatus.IDLE;
    },
  },
  extraReducers: (builder) => {
    builder

      // Forgot password
      .addCase(sendForgotPasswordAsync.pending, (state) => {
        state.forgotPasswordStatus = RequestStatus.PENDING;
      })

      .addCase(sendForgotPasswordAsync.fulfilled, (state, action) => {
        state.forgotPasswordStatus = RequestStatus.SUCCESS;
        state.forgotPasswordEmail = action.payload;
      })

      .addCase(sendForgotPasswordAsync.rejected, (state) => {
        state.forgotPasswordStatus = RequestStatus.ERROR;
      })

      // Reset password
      .addCase(resetPasswordAsync.pending, (state) => {
        state.resetPasswordStatus = RequestStatus.PENDING;
      })

      .addCase(resetPasswordAsync.fulfilled, (state) => {
        state.resetPasswordStatus = RequestStatus.SUCCESS;
      })

      .addCase(resetPasswordAsync.rejected, (state) => {
        state.resetPasswordStatus = RequestStatus.ERROR;
      });
  },
});

export const ForgotPasswordActions = slice.actions;

export const forgotPasswordReducer = slice.reducer;
